import List from '../../containers/MistakeRecords/List';
import Edit from '../../containers/MistakeRecords/Edit';
import Create from '../../containers/MistakeRecords/Create';
import Show from '../../containers/MistakeRecords/Show';

export default { List, Edit, Create, Show };
